// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"261":"locale-fr-json","990":"locale-en-json"}[chunkId] || chunkId) + "." + {"153":"2aaf785d","261":"fc08dd7f","990":"6aa0904b"}[chunkId] + ".js";
};